export const initialState = {
  customerFrequencies: {},
  isLoading: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_CUSTOMER_FREQUENCY_REQUEST': {
      return {
        ...state,
        isLoading: true,
        isCustomerFrequencyTriggered: true,
      };
    }

    case 'GET_CUSTOMER_FREQUENCY_FAILURE': {
      return {
        ...state,
        isLoading: false,
        isCustomerFrequencyTriggered: false,
        error: {
          status: action.status,
        },
      };
    }

    case 'GET_CUSTOMER_FREQUENCY_SUCCESS': {
      const { customer_orders } = action.payload;
      const { customerId, branchId } = action.extra;

      return {
        ...state,
        isLoading: false,
        customerFrequencies: {
          ...state.customerFrequencies,
          // eslint-disable-next-line camelcase
          [customerId]: { branchId, frequency: customer_orders },
        },
      };
    }

    case 'RESET_CUSTOMER_FREQUENCY': {
      return {
        ...state,
        isCustomerFrequencyTriggered: false,
      };
    }

    default:
      return state;
  }
};
